const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    margin: -15,
    position: "relative"
  },
  loading: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    overflow: "hidden",
    zIndex: 10,

    "& svg": {
      color: theme.colors.primary
    }
  },
  // ----------Mobile--------------
  [theme.breakpoints.down('sm')]: {
  },
});

export default styles;
